import React, { Component } from 'react';
import { SeachIcon } from '../Styles';
import { Field, TextInfo } from './TextInputStyles';
import ButtonComp from '../Button/Button';

class TextInput extends Component {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBtnSubmit = this.onBtnSubmit.bind(this);
	}
	renderIcon() {
		switch (this.props.textType) {
			case 'search':
				return <SeachIcon className='search-ico' redIcon={this.props.redIcon} />;
			default:
				return null;
		}
	}
	onChange(e) {
		this.props.onChange(e);
	}
	onFocus(e) {
		this.props.onFocus && this.props.onFocus(e);
	}
	onBtnSubmit(e) {
		e.preventDefault();
		this.props.buttonClick(e);
	}
	render() {
		const { background, borderColor, $width, customClass = '', $height } = this.props;
		return (
			<form>
				<Field
					className={'searchInput ' + customClass}
					background={background}
					borderColor={borderColor}
					$width={$width}
					$height={$height}
					>
					{this.renderIcon()}
					<input
						placeholder={this.props.placeHolder}
						type={this.props.type}
						value={this.props.value}
						onFocus={this.onFocus}
						onChange={this.onChange}
						disabled={this.props.isDisabled}
					/>
					{this.props.showBtn &&
						<ButtonComp
							disabled={this.props.btnDisabled}
							btnType={this.props.btnType}
							btnTxt={this.props.btnTxt}
							btnName={this.props.btnName}
							handleClick={this.onBtnSubmit}
							btnWidth={this.props.btnWidth}
							btnClass={this.props.btnClass}
							type='submit'
						/>}

					{this.props.info && <TextInfo>{this.props.info}</TextInfo>}
				</Field>
			</form>
		);
	}
}

export default TextInput;
